import { EpDevPDocumentTypes } from "../../constants";
import EpDevPUtils from "../../EpDevPUtils";
import { 
  TEnvironmentsApiBasePathParam, 
  TEnvironmentsApiByIdPathParams, 
  TEnvironmentsApiByIdQueryParams, 
  TEnvironmentsApiDeleteCacheQueryParams, 
  TEnvironmentsApiListCachedQueryParams, 
  TEnvironmentsApiReplaceCacheQueryParams 
} from "../types";

const ENVIRONMENTS = "environments";
const CACHE = "cache";
const CACHED = "cached";

export class EpDevPEnvironmentsApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/:${EpDevPUtils.nameOf<TEnvironmentsApiBasePathParam>('organizationId')}/${ENVIRONMENTS}`;
  }
  public static getSubRouteList = (): string => { 
    return EpDevPEnvironmentsApiRoutesFactory.getSubRouteBase();
  }
  public static getSubRouteListCached = (): string => { 
    return `${EpDevPEnvironmentsApiRoutesFactory.getSubRouteBase()}/${CACHED}`;  
  }
  public static getSubRouteById = (): string => {
    return `${EpDevPEnvironmentsApiRoutesFactory.getSubRouteBase()}/:${EpDevPUtils.nameOf<TEnvironmentsApiByIdPathParams>('environmentId')}`;
  }
  private static getSubRouteCache = (): string => {
    return `${EpDevPEnvironmentsApiRoutesFactory.getSubRouteBase()}/${CACHE}`;
  }
  public static postSubRouteCacheCreate = (): string => {
    return `${EpDevPEnvironmentsApiRoutesFactory.getSubRouteCache()}`;
  }
  public static putSubRouteCacheReplace = (): string => {
    return `${EpDevPEnvironmentsApiRoutesFactory.getSubRouteCache()}`;
  }
  public static deleteSubRouteCacheDelete = (): string => {
    return `${EpDevPEnvironmentsApiRoutesFactory.getSubRouteCache()}`;
  }
}

export class EpDevPEnvironmentsApiPathsFactory {

  public static createListPath({ organizationId }: {
    organizationId: string;
  }): string {
    return `/${organizationId}/${ENVIRONMENTS}`;
  }

  public static createListCachedPath({ organizationId, documentTypes }: {
    organizationId: string;
    documentTypes?: Array<EpDevPDocumentTypes>;
  }): string {
    const queryParams: string[] = [];
    if(documentTypes !== undefined && documentTypes.length > 0) {
      queryParams.push(`${EpDevPUtils.nameOf<TEnvironmentsApiListCachedQueryParams>("documentTypes")}=${documentTypes.join(',')}`);
    }
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${ENVIRONMENTS}/${CACHED}?${queryString}`;
  }

  public static createByIdPath({
    organizationId,
    environmentId,
    add2CacheId,
  }:{
    organizationId: string;
    environmentId: string;
    add2CacheId?: string;
  }): string {
    const queryParams: string[] = [];
    if(add2CacheId !== undefined) {
      queryParams.push(`${EpDevPUtils.nameOf<TEnvironmentsApiByIdQueryParams>("add2CacheId")}=${add2CacheId}`);
    }
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${ENVIRONMENTS}/${environmentId}?${queryString}`;
  }

  public static createCacheCreatePath({
    organizationId,
  }:{
    organizationId: string;
  }): string {
    return `/${organizationId}/${ENVIRONMENTS}/${CACHE}`;
  }

  public static createCacheReplacePath({
    organizationId,
    sourceCacheId,
    organizationDocumentType
  }:{
    organizationId: string;
    sourceCacheId: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): string {
    const queryParams: string[] = [];
    queryParams.push(`${EpDevPUtils.nameOf<TEnvironmentsApiReplaceCacheQueryParams>("sourceCacheId")}=${sourceCacheId}`);
    queryParams.push(`${EpDevPUtils.nameOf<TEnvironmentsApiReplaceCacheQueryParams>("organizationDocumentType")}=${organizationDocumentType}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${ENVIRONMENTS}/${CACHE}?${queryString}`;
  }

  public static createCacheDeletePath({ organizationId, tempCacheId, organizationDocumentType }:{
    organizationId: string;
    tempCacheId?: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): string {
    const queryParams: string[] = [];
    if(tempCacheId) queryParams.push(`${EpDevPUtils.nameOf<TEnvironmentsApiDeleteCacheQueryParams>("tempCacheId")}=${tempCacheId}`);
    queryParams.push(`${EpDevPUtils.nameOf<TEnvironmentsApiDeleteCacheQueryParams>("organizationDocumentType")}=${organizationDocumentType}`);
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${organizationId}/${ENVIRONMENTS}/${CACHE}?${queryString}`;
  }

}

